import { Anchor, Card, Center, Container, Text, Title } from '@mantine/core';
import { IconMail } from '@tabler/icons-react';
import Metadata from '../components/Metadata';
import { Page } from '../constants/pageTitles';

const ResetPasswordEmailSentPage = () => {
  return (
    <div>
      <Metadata title={`${Page['resetPasswordSentEmail']}`} />
      <Center pt={60} h="100%">
        <Container size="xs" w="100%">
          <Card withBorder p="lg" ta="center">
            <Title order={1} mb="lg">
              <strong>Check your email!</strong>
            </Title>
            <br />
            <Text ta="center">
              <IconMail size={80} />
            </Text>
            <br />
            <br />
            <Text size="lg">
              We have sent a reset password link to the email provided. Please check your email and follow the
              instructions to reset your password.
            </Text>
          </Card>
          <br />
          <br />
          <Text ta="center">
            Remembered your pasword? <Anchor href="#/login">Log in here.</Anchor>
          </Text>
        </Container>
      </Center>
    </div>
  );
};

export default ResetPasswordEmailSentPage;
